import { observer } from 'mobx-react-lite';
import { Button, Message, Icon, Divider, Container, Label } from 'semantic-ui-react';
import { ErrorMessage, Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useStore } from '../../app/stores/store';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import MyTextInput from '../../app/common/form/MyTextInput';

export default observer(function LoginForm() {
    const {userStore, modalStore} = useStore();
    const { openModal, closeModal } = modalStore;

    function handleForgotPasswordButton() {
        closeModal();
        openModal(<ForgotPasswordForm />);
    }

    function handleSignupButton() {
        closeModal();
        openModal(<RegisterForm isRedirect={false} />);
    }

    return (
        <Formik
            initialValues={{subscriberEmail: '', securityOverrideKeyword: '', error: null}}
            onSubmit={(values, {setErrors}) => userStore.login(values).catch(error => 
                setErrors({error: error.response.data}))}
            validationSchema={Yup.object({
                subscriberEmail: Yup.string().required('Required').email('Email must be a valid email'),
                securityOverrideKeyword: Yup.string()
                    .required('Required')
            })}
        >
            {({handleSubmit, isSubmitting, errors, values}) => (
                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                    <Message icon>
                        <Icon name='user' />
                        <Message.Content>
                            <Message.Header>LOGIN to your WSF Carpool/Vanpool Account</Message.Header>
                            Login to manage your WSF Carpool/Vanpool Permit account.
                        </Message.Content>
                    </Message>

                    <label 
                        className={values.subscriberEmail ? 'label-visible input-label' : 'input-label'}
                    >Email</label>
                    <MyTextInput name='subscriberEmail' placeholder='Email' />

                    <label 
                        className={values.securityOverrideKeyword ? 'label-visible input-label' : 'input-label'}
                    >Password</label>
                    <MyTextInput name='securityOverrideKeyword' placeholder='Password' type='password' />

                    <ErrorMessage 
                        name='error' render={() => 
                        <Label style={{marginBottom: 10}} basic color='red' content={errors.error}/>}
                    />

                    <Button 
                        loading={isSubmitting} 
                        type='submit'
                        color='teal' 
                        content='Login'
                        fluid 
                    />
                    
                    <Divider hidden />

                    <Container className='text-center default-text-size'>
                        <Label basic
                            onClick={handleForgotPasswordButton}
                            className='text-label default-text-size'
                        >{'Forgot password?'}</Label>
                    </Container>
                    <Divider></Divider>
                    
                    <Container className='text-center default-text-size'>
                        Don't have an account?
                        <Label basic
                            onClick={handleSignupButton}
                            className='text-label default-text-size'
                        >{'Sign Up'}</Label>
                    </Container>
                </Form>
            )}
        </Formik>
    )
})